<template lang="pug">
div
  sticky(className="sub-navbar")
    el-button(type='success' size='mini' icon='el-icon-plus' @click='toCreate') 新規作成
    el-button(type='primary' size='mini' icon='el-icon-upload' @click='showModal') 順番変更
  .contents-container
    .c-search
      el-input(placeholder='検索条件を入れてください', v-model='search')
    el-table.c-table(:data='list' style='width: 100%')
      el-table-column(prop='profile_image' label='' width='120')
        template(slot-scope='scope')
          template(v-if='scope.row.profile_image')
            img.c-thumb__item--1-1(:src='scope.row.profile_image.uri')
          template(v-else)
            .c-thumb__item--1-1
              p no image
      el-table-column(prop='name.ja', label='Name')
      el-table-column(prop='title.ja', label='Title')
      el-table-column(prop='status', label='Status', width='100')
        template(slot-scope='scope')
          el-tag(:type="scope.row.status === 1 ? 'success' : 'info'") {{status(scope.row.status)}}
      el-table-column(label='', width='100')
        template(slot-scope='scope')
          el-button(size='mini', @click='handleEdit(scope.row, "talentDetail")' icon='el-icon-edit') Edit
    template(v-if='list.length')
      modal-sort-element(:visible='modalvisible' @hideModal='hideModal' @saveSort='saveSort' :list='list' type='list' displaykey='name')
</template>

<script>
import list from '@/mixins/list'
import Sticky from '@/components/Element/Sticky'
import ModalSortElement from '@/components/Element/Modal/SortElement'
export default {
  name: 'PagesTalent',
  mixins: [list],
  data () {
    return {
    }
  },
  methods: {
    init () {
      this.getList()
    },
    toCreate () {
      this.$router.push({name: 'talentCreate'})
    }
  },
  created () {
    this.init()
  },
  components: {
    Sticky,
    ModalSortElement
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Talent/index.vue